"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTP001Styled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.DSTP001Styled = styled_components_1.default.div `
	.survey_checkbox_item {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: space-between;

		.del_btn {
			color: var(--color-pink, #f46790);
			text-align: center;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 28px;
			letter-spacing: -0.02em;
			font-weight: 400;
			text-decoration: underline;
			position: relative;
			width: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}
	}

	.popup-list-002-wrapper {
		gap: 12px;

		.scroll-content {
			flex: 1;
		}
	}

	.field-short {
		flex-wrap: wrap;
	}

	.task-info {
		display: flex;
		width: 100%;
		height: 100%;
		flex-direction: row;
		gap: 24px;
	}

	.test-item {
		display: flex;
		flex-direction: column;
		flex: 1;
		width: 100%;
		height: 100%;
	}

	.test-item-notice {
		display: flex;
		flex-direction: column;
		flex: 1;
		width: 100%;
		align-items: center;
		justify-content: center;
		gap: 12px;
		p {
			align-content: center;
			color: #83868a;
			font-size: 18px;
		}
	}
	.test-item-attachment {
		display: flex;
		flex-direction: column;
		flex: 1;
		width: 100%;
		align-items: center;
	}

	.subject-info-wrap {
		display: flex;
		flex-direction: column;
		gap: 24px;
		width: 100%;
	}

	.start-now {
		justify-content: end;
	}
	
	.assignment-checkbox-txt {
		flex-wrap: wrap;
	}

	.checkbox {
		min-height: 36px;
		padding-left: 8px;
	}

	.field-description {
		font-size: 14px;
		color: #888;
		display: flex;
		justify-content: flex-start;
		width: 100%;
	}

	.text-line {
		padding: 6px !important;
	}

	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
	${props => props.$isPopup && popupStyles}
	${props => props.$isBackOffice && backOfficeResponsiveStyles}
`;
// 관리자(백오피스) 등록/수정 전용: 사이드바로 콘텐츠 영역이 좁아 윈도우 기반 반응형(useGlobalState)으로는
// desktop 2단이 유지되어 잘림. 윈도우가 아닌 '컨테이너 폭'에 반응하도록 flex-wrap으로 폼/문항 영역을
// 한 줄에 못 담으면 세로로 스택시켜 기본 테스트 등록의 반응형 동작을 따른다.
const backOfficeResponsiveStyles = (0, styled_components_1.css) `
	/* 백오피스 등록/수정: height:100% 체인은 그대로 유지하고, 바운드된 wrapper에 overflow:auto를 줘서
	   출제유형 선택(편집영역 렌더) 시에도 스크롤이 유지되도록 한다.
	   (윈도우가 아닌 '컨테이너 폭'에 반응하는 flex-wrap도 유지) */
	.task-info-container-wrapper {
		overflow-y: auto;
		overflow-x: hidden;
	}
	.task-info {
		flex-wrap: wrap;
	}
	.task-info-container {
		width: auto;
		flex: 1 1 340px;
		min-width: min(340px, 100%);
		max-width: 100%;
	}
	.test-item {
		flex: 2 1 360px;
		min-width: min(360px, 100%);
		max-width: 100%;
	}
`;
const mobileStyles = (0, styled_components_1.css) `
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;

	.text-line {
		padding: 10px !important;
	}

	.mobile-file-wrap {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 5px;
	}

	.checkbox-item {
		&.scoreBlank {
			span {
				font-size: 12px;
			}
		}
	}

	.box {
		min-height: 92px;
	}

	.button {
		z-index: 1;
	}

	.task-info-container-wrapper {
		overflow: hidden;
		background: var(--color-white, #ffffff);
		border-radius: 0px 0px 8px 8px;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		flex: 1;
		height: 100%;
	}

	.eval-table-wrap {
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 0px 0px 1px 0px;
		padding: 10px 0px 24px 0px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: 100%;
		position: relative;

		.popup-list-002-wrapper {
			display: flex;
			flex-direction: column;
			width: 100%;
			align-items: flex-end;
			justify-content: flex-start;
			gap: 12px;
		}

		.popup-list-002,
		.popup-list-002 * {
			box-sizing: border-box;
		}
		.popup-list-002 {
			width: 100%;
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-end;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.scroll-content {
				padding: 0;
			}

			.table-header {
				width: 100%;
				display: flex;
				flex-direction: row;
				gap: 4px;
				align-items: flex-start;
				justify-content: flex-start;
				flex-shrink: 0;
				position: relative;
			}

			.table-header-item {
				background: var(--color-silver, #f3f4f8);
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px 0px 0px 0px;
				padding: 10px 16px 10px 16px;
				display: flex;
				flex-direction: row;
				gap: 20px;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: relative;
				height: 100%;

				p {
					color: var(--color-black, #101010);
					text-align: center;
					font-family: 'Noto Sans KR', sans-serif;
					font-size: 12px;
					line-height: 150%;
					letter-spacing: -0.02em;
					font-weight: 400;
					position: relative;
				}
			}

			.scroll-content {
				display: flex;
				flex-direction: column;
				gap: 0px;
				align-items: center;
				justify-content: flex-start;
				flex-shrink: 0;
				width: 100%;
				position: relative;

				.item {
					display: flex;
					flex-direction: row;
					gap: 4px;
					align-items: flex-start;
					justify-content: flex-start;
					flex-shrink: 0;
					position: relative;
					width: 100%;

					.body-item {
						padding: 6px 4px 6px 4px;
						display: flex;
						flex-direction: row;
						gap: 20px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
					}

					input {
						background: #ffffff;
						border-radius: 4px;
						border-style: solid;
						border-color: var(--color-grey-w, #b6bac0);
						border-width: 1px;
						padding: 4px 10px 4px 10px;
						display: flex;
						flex-direction: row;
						gap: 6px;
						align-items: center;
						justify-content: center;
						flex-shrink: 0;
						position: relative;
						color: var(--color-grey-l, #83868a);
						text-align: left;
						font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
						font-size: var(--b5-font-size, 10px);
						line-height: var(--b5-line-height, 22px);
						font-weight: var(--b5-font-weight, 400);
						position: relative;
					}
				}
			}
		}
	}

	.field-global-001 {
		.mobile-date-wrap {
			flex-direction: column;
			align-items: flex-start;
		}
	}

	.attach-file-wrap {
		width: 100%;
		gap: 6px;
		display: flex;
		flex-direction: column;

		button {
			.overText {
				font-size: 12px;
			}
		}
	}

	.assignment-info-wrap {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
	}

	.subject-info-wrap {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
	}

	.eval-info-wrap {
		width: 100%;
		display: flex;
		flex-direction: row;
		gap: 16px;
	}

	.border-btm {
		display: flex;
		width: 100%;
		height: 100%;
	}

	.border-btm {
		border: none;
	}

	.field-description {
		font-size: 12px;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	padding: ${props => (props.$isLive ? '0px' : '20px')};

	.text-line {
		padding: 8px !important;
	}

	.field-description {
		font-size: 12px;
	}

	.scoreBlank,
	.assignment-checkbox-txt {
		color: var(--color-black, #101010);
		text-align: center;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;

		span {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.box {
		min-height: 92px;
	}

	.task-info-container-wrapper {
		overflow: hidden;
		background: var(--color-white, #ffffff);
		border-radius: 0px 0px 8px 8px;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		flex: 1;
		height: 100%;
	}

	.task-info-container {
		padding: 0px 0px 0px 0px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: 50%;
		position: relative;
		padding: 24px;
		border: 1px solid #e6e8ed;
		border-radius: 8px;
		overflow: auto;
		// min-height: 370px;

		.popup-list-002-wrapper {
			display: flex;
			flex-direction: column;
			width: 100%;
			align-items: flex-end;
			justify-content: flex-start;
		}

		.popup-list-002,
		.popup-list-002 * {
			box-sizing: border-box;
		}
		.popup-list-002 {
			width: 100%;
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-end;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.table-header {
				width: 100%;
				display: flex;
				flex-direction: row;
				gap: 4px;
				align-items: flex-start;
				justify-content: flex-start;
				flex-shrink: 0;
				position: relative;
			}

			.table-header-item {
				background: var(--color-silver, #f3f4f8);
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px 0px 0px 0px;
				padding: 10px 16px 10px 16px;
				display: flex;
				flex-direction: row;
				gap: 20px;
				align-items: flex-start;
				justify-content: center;
				flex-shrink: 0;
				position: relative;

				p {
					color: var(--color-black, #101010);
					text-align: center;
					font-family: 'Noto Sans KR', sans-serif;
					font-size: 10px;
					line-height: 150%;
					letter-spacing: -0.02em;
					font-weight: 400;
					position: relative;
				}
			}

			.scroll-content {
				display: flex;
				flex-direction: column;
				gap: 0px;
				align-items: center;
				justify-content: flex-start;
				flex-shrink: 0;
				width: 100%;
				position: relative;

				.sel_eval_item {
					color: var(--color-grey-l, #83868a);
					text-align: center;
					font-family: 'Noto Sans KR', sans-serif;
					font-size: 10px;
					line-height: 150%;
					letter-spacing: -0.02em;
					font-weight: 400;
				}

				.item {
					display: flex;
					flex-direction: row;
					gap: 4px;
					align-items: flex-start;
					justify-content: flex-start;
					flex-shrink: 0;
					position: relative;
					width: 100%;

					.body-item {
						padding: 8px 16px 8px 16px;
						display: flex;
						flex-direction: row;
						gap: 20px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
					}

					input {
						background: #ffffff;
						border-radius: 4px;
						border-style: solid;
						border-color: var(--color-grey-w, #b6bac0);
						border-width: 1px;
						padding: 4px 10px 4px 10px;
						display: flex;
						flex-direction: row;
						gap: 6px;
						align-items: center;
						justify-content: center;
						flex-shrink: 0;
						position: relative;
						color: var(--color-grey-l, #83868a);
						text-align: left;
						font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
						font-size: var(--b5-font-size, 12px);
						line-height: var(--b5-line-height, 22px);
						font-weight: var(--b5-font-weight, 400);
						position: relative;
					}
				}
			}
		}
	}

	.assignment-info-wrap {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
	}

	.test-item-notice {
		p {
			font-size: 16px;
		}
	}

	.btn-container {
		.button {
			width: 116px;
		}
	}

	.dst_attach_file {
		align-self: end;
	}

	.border-btm {
		display: flex;
		width: 100%;
		min-height: calc(100% - 70px);
		height: min-content;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;

	.border-btm {
		display: flex;
		width: 100%;
		flex: 1;
		border-bottom: 1px solid #e6e8ed;
		padding-bottom: 24px;
	}

	.box {
		min-height: 92px;
	}

	.task-info-container-wrapper {
		background: var(--color-white, #ffffff);
		border-radius: 0px 0px 8px 8px;
		display: flex;
		flex-direction: column;
		gap: 24px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		flex: 1;
		height: 100%;
	}

	.task-info-container {
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: flex-start;
		width: 35%;
		position: relative;
		padding: 24px;
		border: 1px solid #e6e8ed;
		border-radius: 8px;
		flex-shrink: 0;

		.popup-list-002-wrapper {
			display: flex;
			flex-direction: column;
			width: 100%;
			align-items: flex-end;
			justify-content: flex-start;
		}

		.popup-list-002,
		.popup-list-002 * {
			box-sizing: border-box;
		}
		.popup-list-002 {
			width: 100%;
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-end;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.table-header {
				width: 100%;
				display: flex;
				flex-direction: row;
				gap: 4px;
				align-items: flex-start;
				justify-content: flex-start;
				flex-shrink: 0;
				position: relative;
				border-bottom: none;
				padding: 0;
			}

			.table-header-item {
				background: var(--color-silver, #f3f4f8);
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px 0px 0px 0px;
				padding: 10px 16px 10px 16px;
				display: flex;
				flex-direction: row;
				gap: 20px;
				align-items: flex-start;
				justify-content: center;
				flex-shrink: 0;
				position: relative;

				p {
					color: var(--color-black, #101010);
					text-align: center;
					font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
					font-size: var(--b5-font-size, 12px);
					line-height: var(--b5-line-height, 22px);
					font-weight: var(--b5-font-weight, 400);
					position: relative;
				}
			}

			.scroll-content {
				display: flex;
				flex-direction: column;
				gap: 0px;
				align-items: center;
				justify-content: flex-start;
				flex-shrink: 0;
				width: 100%;
				position: relative;

				.item {
					display: flex;
					flex-direction: row;
					gap: 4px;
					align-items: flex-start;
					justify-content: flex-start;
					flex-shrink: 0;
					position: relative;
					width: 100%;
					padding: 0;
					border-bottom: none;

					.body-item {
						padding: 8px 16px 8px 16px;
						display: flex;
						flex-direction: row;
						gap: 20px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
					}

					input {
						background: #ffffff;
						border-radius: 4px;
						border-style: solid;
						border-color: var(--color-grey-w, #b6bac0);
						border-width: 1px;
						padding: 4px 10px 4px 10px;
						display: flex;
						flex-direction: row;
						gap: 6px;
						align-items: center;
						justify-content: center;
						flex-shrink: 0;
						position: relative;
						color: var(--color-grey-l, #83868a);
						text-align: left;
						font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
						font-size: var(--b5-font-size, 12px);
						line-height: var(--b5-line-height, 22px);
						font-weight: var(--b5-font-weight, 400);
						position: relative;
					}
				}
			}
		}
	}

	.subject-info-wrap {
		border-top: 1px solid #e6e8ed;
		padding-top: 24px;
	}

	.assignment-info-wrap {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;
	}

	.survey_wrapper {
		overflow: auto;
	}
`;
const popupStyles = (0, styled_components_1.css) `
	.task-info-container-wrapper {
		overflow: auto;
	}

	.task-info-container {
		padding: 0px;
		width: 100%;
		border: none;
		${props => props.$isTablet && `overflow: unset;`}
	}

	.border-btm {
		overflow: unset;
	}
`;
